<template>
  <nav class="navbar" v-if="isAuthenticated">
    <div class="nav-container">
      <div class="nav-brand">
        <a href="/#/">🏠 Home to Live</a>
      </div>
      <ul class="nav-menu">
        <li><a href="/#/" class="nav-link" :class="{ active: isActiveRoute('/') }">Dashboard</a></li>
        <li><a href="/#/staff" class="nav-link" :class="{ active: isActiveRoute('/staff') }">Staff</a></li>
        <li><a href="/#/schedule" class="nav-link" :class="{ active: isActiveRoute('/schedule') }">Schedule</a></li>
        <li><a href="/settings.html" class="nav-link">Settings</a></li>
      </ul>
      <div class="nav-user">
        <span class="user-name">{{ userName }}</span>
        <a href="/api/logout.jsp" class="logout-btn">Logout</a>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const isAuthenticated = ref(false)
const userName = ref('Staff User')

// Check if route is active
const isActiveRoute = (path) => {
  return route.path === path
}

// Function to check JSP session
const checkSession = async () => {
  try {
    const response = await fetch('/api/check-session.jsp')
    const data = await response.json()
    
    if (data.authenticated) {
      isAuthenticated.value = true
      userName.value = data.user || 'Staff User'
    } else {
      isAuthenticated.value = false
      userName.value = 'Staff User'
    }
  } catch (error) {
    // Not authenticated, keep navigation hidden
    isAuthenticated.value = false
    userName.value = 'Staff User'
  }
}

// Check JSP session on component mount
onMounted(checkSession)

// Re-check session whenever route changes (to catch logout/return scenarios)
watch(route, () => {
  checkSession()
})
</script>

<style scoped>
.navbar {
  background: #2c3e50;
  color: white;
  padding: 1rem 0;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nav-brand a {
  color: white;
  text-decoration: none;
  font-size: 1.5rem;
  font-weight: bold;
}

.nav-menu {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 2rem;
}

.nav-link {
  color: white;
  text-decoration: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  transition: background-color 0.3s ease;
}

.nav-link:hover,
.nav-link.active {
  background-color: #34495e;
}

.nav-user {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.user-name {
  color: #ecf0f1;
}

.logout-btn {
  background: #e74c3c;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  text-decoration: none;
  transition: background-color 0.3s ease;
}

.logout-btn:hover {
  background: #c0392b;
}

@media (max-width: 768px) {
  .nav-container {
    flex-direction: column;
    gap: 1rem;
  }
  
  .nav-menu {
    flex-wrap: wrap;
    justify-content: center;
  }
}
</style>
